import {connect} from "react-redux";
import { requestUsers } from "../../redux/actions/actions.js";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Search = (props) => {
    const[searchText, setSearchText] = useState(null);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/users");
    }

    return(
        <form className="search_form" onSubmit={(event)=>props.onRequestUsers(event,searchText)}>
            <input type="search" placeholder="Search dZen" id="search_button" className={`search_button profile_edit_form_input_color background_change_${props.color_background}`} onClick={handleClick} onChange={(e)=>setSearchText(e.target.value)} />
        </form>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onRequestUsers: (event, text) => {
            event.preventDefault();
            dispatch(requestUsers(text));
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Search);